import qs from 'qs'
import { DeserializeFilters } from '../../../hooks/table-pages/use-endpoint-query-parameters'
import FormValues from '../components/filters-form/types/form-values'

export const deserializeFilters: DeserializeFilters = filtersString => {
    const formValues = qs.parse(filtersString) as Partial<FormValues>
    const { taskStatus, shipmentId, manager } = formValues

    const filters: Record<string, any> = {}

    if (taskStatus) {
        filters.taskStatus = { $eq: taskStatus }
    }

    if (shipmentId) {
        const id = Number(shipmentId)
        if (!Number.isNaN(id)) {
            filters.shipment = {
                ...(filters.shipment || {}),
                id: { $eq: id },
            }
        }
    }

    if (manager) {
        filters.shipment = {
            ...(filters.shipment || {}),
            user_audit: {
                created_by_permissions_user: {
                    documentId: { $eq: manager },
                },
            },
        }
    }

    return filters
}
